import { useRef, useState } from "react";
import { LockKeyhole, Check } from "lucide-react";
import MpxModal from "./MpxModal.jsx";
import GoogleCredentialButton from "./GoogleCredentialButton.jsx";

export default function ReauthModal({ userEmail, onReauth, onLogout }) {
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const inFlight = useRef(false);
  const handleCredential = async credential => {
    if (inFlight.current) return;
    inFlight.current = true;
    setLoading(true);
    setErrorMsg("");
    try { await onReauth(credential); }
    catch (error) {
      setErrorMsg(error?.message === "INVALID_REAUTH_TOKEN"
        ? "기존에 사용하던 계정으로 로그인해 주세요. 다른 계정은 로그아웃 후 사용할 수 있습니다."
        : "재인증에 실패했습니다. 연결을 확인한 뒤 Google 버튼으로 다시 시도해 주세요.");
    } finally { inFlight.current = false; setLoading(false); }
  };
  return <MpxModal open size="sm" title="다시 연결하고 이어서 작업하세요"
    closeOnBackdrop={false} closeOnEsc={false} overlayClassName="mpx-modal__backdrop--reauth" className="mpx-reauth">
    <div className="mpx-reauth__icon"><LockKeyhole aria-hidden="true" /></div>
    <p className="mpx-reauth__lead">로그인 확인이 필요합니다</p>
    <p className="mpx-reauth__description">오래 자리를 비운 경우 Google 계정을 다시 확인합니다. 아래 버튼으로 로그인하면 보던 화면에서 이어집니다.</p>
    {userEmail && <p className="mpx-reauth__account">{userEmail}</p>}
    <div className="mpx-reauth__preserved"><Check size={16} aria-hidden="true" />선택한 브랜드와 현재 화면이 유지됩니다</div>
    {errorMsg && <p className="mpx-reauth__error" role="alert">{errorMsg}</p>}
    <GoogleCredentialButton onCredential={handleCredential} busy={loading} />
    {loading && <p role="status" className="mpx-reauth__status">계정을 확인하고 있습니다…</p>}
    <button type="button" className="mpx-btn mpx-btn--ghost mpx-reauth__logout" onClick={onLogout} disabled={loading}>안전하게 로그아웃</button>
  </MpxModal>;
}
